import React from "react"

const IconWarn = ({ fill }) => (
  <svg width="5" height="14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.375 11.812A2.19 2.19 0 012.187 14 2.19 2.19 0 010 11.812a2.19 2.19 0 012.187-2.187 2.19 2.19 0 012.188 2.187zM.253.69A.656.656 0 01.91 0h2.557c.376 0 .675.314.656.689L3.75 8.127a.656.656 0 01-.656.623H1.281a.656.656 0 01-.656-.623L.253.689z"
      fill={fill}
    />
  </svg>
)

export default IconWarn
